module.exports = require('./helpers/bundle-url').getBundleURL('3whur') + "logo-dark.eefe0b7f.svg";